import Cargos from '@/models/Cargos'

export default [
  {
    path: '/atendimento/clientes',
    name: 'rota-clientes',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Clientes',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Clientes',
      icon: 'user',
    },
    component: () => import(/* webpackChunkName: "clientes" */ '../views/clientes/Clientes.vue'),
  },
  {
    path: '/atendimento/clientes/cadastro',
    name: 'rota-clientes-cadastro',
    autenticado: true,
    cargo: [Cargos.ATENDENTE, Cargos.BARBEIRO, Cargos.LIDER, Cargos.BARBEIRO_CAIXA],
    titulo: 'Cadastro de clientes',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "clientes" */ '../views/clientes/cadastro/ClientesCadastro.vue'),
  },
  {
    path: '/atendimento/clientes/:id',
    name: 'rota-clientes-alteracao',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Alteração de clientes',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "clientes" */ '../views/clientes/cadastro/ClientesCadastro.vue'),
  },
]
